<form nz-form [formGroup]="form" [nzLayout]="'inline'" class="req-row">
    <p
        *ngIf="element.label"
        style="
            text-align: left;
            margin-top: 7px;
            margin-bottom: 7px;
            padding-right: 16px;
        "
    >
        {{ element.label }}
    </p>

    <nz-form-item
        *ngFor="let field of fields"
        [style]="
            'max-width: 100%;flex-wrap: nowrap;' +
            (field.type !== 'boolean' ? 'flex: 1 0 100px;' : '')
        "
    >
        <nz-form-label
            [style]="field.type === 'boolean' ? 'order: 1;' : 'order: 0;'"
            *ngIf="field.label"
            [nzNoColon]="field.type === 'boolean'"
            [nzFor]="field.id"
            [nzRequired]="field.required"
            style="white-space: normal; flex: none !important;"
            >{{ field.label }}</nz-form-label
        >

        <nz-form-control
            [ngStyle]="{'order': field.type === 'boolean' ? '0': '1'}"
            style="flex: none !important;"
            nzErrorTip="Error"
        >
            <label
                *ngIf="field.type === 'boolean'; else inputTmp"
                class="check"
                nz-checkbox
                [formControlName]="field.id"
            ></label>
            <ng-template #inputTmp>
                <input
                    *ngIf="field.type === 'string' || field.type === 'number'"
                    nz-input
                    [disabled]="true"
                    [type]="field.type"
                    [formControlName]="field.id"
                    [id]="field.id"
                />
            </ng-template>
        </nz-form-control>
    </nz-form-item>
</form>
